import BoxListButton from "@components/BoxListButton";
import { PARTNER_DETAIL, PARTNER_MODIFY } from "@constants/routes";
import { timestampToString } from "@helpers/dates.format";
import IPartner from "@interfaces/partner";

const listPartnerMapper = (items: IPartner[], handleDelete: Function) =>
  items.map(({ uuid, name, createdAt, updatedAt, order }) => ({
    uuid,
    order,
    name,
    createDate: timestampToString(createdAt),
    _createDateTs: createdAt ?? 0,
    updateDate: timestampToString(updatedAt),
    _updateDateTs: updatedAt ?? 0,
    actions: (
      <BoxListButton
        uuid={uuid}
        description={name}
        detailRoute={PARTNER_DETAIL}
        modifyRoute={PARTNER_MODIFY}
        handleDelete={handleDelete}
      />
    ),
  }));

export default listPartnerMapper;
